module.exports = __webpack_public_path__ + "static/media/Login-img.13ee3404.jpeg";